define.alias("ember-cli-string-helpers/helpers/classify", "media/helpers/classify");